import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { roleSelectOptions } from "../../variables/Variables.jsx";
import {
    fetchUserRequest,
    createUserRequest,
    editUserRequest,
} from "../../api/user";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect.jsx";

class UserForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resource: {
                email: null,
                password: null,
                role: null,
                employee: {},
            },
            employeeSelectOptions: [],
            formErrors: null,
        };
    }

    componentDidMount() {
        const { match } = this.props;
        if (match.params.id) {
            this.fetchUser(match.params.id);
        }

        // employeeSelectOptionRequest(
        //     (result) => this.setState({ employeeSelectOptions: result }),
        //     (error) => this.setState({ error: "There was an error" }),
        // );
    }

    fetchUser = (id) => {
        fetchUserRequest(
            id,
            (result) => this.setState({ resource: result }),
            (error) => console.log(error),
        );
    };

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    goToList = () => {
        this.props.history.push("/users/list");
    };

    errorMessage = (name, message) => {
        const { formErrors } = this.props;
        return (
            <>
                {formErrors && formErrors[name] && (
                    <div className="form-text text-danger sz-11px">
                        {message}
                    </div>
                )}
            </>
        );
    };

    validate = () => {
        const { email, password, role, employee } = this.state.resource;

        const errors = {};
        if (!email) {
            errors.email = true;
        }

        if (!password) {
            errors.password = true;
        }

        if (!role) {
            errors.role = true;
        }

        if (!employee) {
            errors.employee = true;
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ formErrors: errors });
        } else {
            this.setState({ formErrors: null });
            this.save();
        }
    };

    save = () => {
        const { match } = this.props;
        const isNewRecord = !match.params.id;
        const data = this.state.resource;

        if (isNewRecord) {
            createUserRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        } else {
            editUserRequest(
                match.params.id,
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        }
    };

    saveSuccess = () => {
        this.setState({
            errorMessage: null,
            successMessage: "User saved successfully",
        });
        this.goToList();
    };

    saveFailure = () => {
        this.setState({
            errorMessage: "There was an error saving user",
            successMessage: null,
        });
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                employee: employeeValue.value,
            },
        }));
    };

    render() {
        const { email, password, role } = this.state.resource;

        const { match } = this.props;
        const isNewRecord = !match.params.id;

        return (
            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card
                            title={isNewRecord ? "Create user" : "Edit User"}
                            content={
                                <form>
                                    <Button
                                        className="card-top-btn btn-primary"
                                        onClick={() => this.goToList()}
                                    >
                                        Back to List
                                    </Button>
                                    <FormGroup>
                                        <ControlLabel>
                                            Email{" "}
                                            <span className="required-star">
                                                *
                                            </span>
                                        </ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={this.handleFormChange}
                                            placeholder=""
                                        />
                                        {this.errorMessage(
                                            "email",
                                            "Email can't be empty",
                                        )}
                                    </FormGroup>
                                    {isNewRecord && (
                                        <FormGroup>
                                            <ControlLabel>
                                                Password{" "}
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="password"
                                                value={password}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                            {this.errorMessage(
                                                "password",
                                                "Password can't be empty",
                                            )}
                                        </FormGroup>
                                    )}
                                    <FormGroup>
                                        <ControlLabel>
                                            Role{" "}
                                            <span className="required-star">
                                                *
                                            </span>
                                        </ControlLabel>
                                        <FormControl
                                            onChange={this.handleFormChange}
                                            componentClass="select"
                                            name="role"
                                            value={role}
                                        >
                                            <option value="">Select</option>
                                            {roleSelectOptions.map((option) => {
                                                return (
                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                );
                                            })}
                                        </FormControl>
                                        {this.errorMessage(
                                            "role",
                                            "Role can't be empty",
                                        )}
                                    </FormGroup>
                                    {isNewRecord ? (
                                        <FormGroup>
                                            <ControlLabel>
                                                Employee
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <EmployeeAsyncSelect
                                                onChange={this.handleChange}
                                            />
                                            {/* <FormControl 
                                onChange={this.handleFormChange}
                                componentClass="select" 
                                name="employee"
                                value={employee && employee._id}
                            >
                            <option value="">Select</option>
                            {employeeSelectOptions.map(option => {
                                return (
                                <option
                                    key={option.value}
                                    value={option.value}
                                >
                                    {option.label}
                                </option>
                                );
                            })}
                            </FormControl> */}
                                            {this.errorMessage(
                                                "employee",
                                                "Employee can't be empty",
                                            )}
                                        </FormGroup>
                                    ) : (
                                        <FormGroup>
                                            <ControlLabel>
                                                Employee
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <EmployeeAsyncSelect
                                                onChange={this.handleChange}
                                                disabled={true}
                                            />
                                            {/* <FormControl
                                                readOnly
                                                componentClass="select"
                                                name="employee"
                                                value={employee && employee._id}
                                            >
                                                <option value="">Select</option>
                                                {employeeSelectOptions.map(
                                                    (option) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    option.value
                                                                }
                                                                value={
                                                                    option.value
                                                                }
                                                            >
                                                                {option.label}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </FormControl> */}
                                            {this.errorMessage(
                                                "employee",
                                                "Employee can't be empty",
                                            )}
                                        </FormGroup>
                                    )}

                                    <Button
                                        bsStyle="primary"
                                        pullRight
                                        fill
                                        onClick={this.validate}
                                    >
                                        {isNewRecord
                                            ? "Create"
                                            : "Save Changes"}
                                    </Button>
                                    <div className="clearfix" />
                                </form>
                            }
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default UserForm;
